import { useState, useEffect } from "react";
import { FetchedReportData } from "../../types";
import useFetchWithAuth from "./useFetchWithAuth";
import { getApiUrl } from "../../utils/api";
import devLogger from "../../utils/devLogger";

const useFetchUserReports = () => {
  const { fetchWithAuth } = useFetchWithAuth();
  const [data, setData] = useState<DataType>();
  const [fetchingReports, setFetchingReports] = useState(false);
  const [fetchReportsError, setFetchReportsError] = useState<string | null>(
    null
  );

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setFetchingReports(true);

        const url = getApiUrl("/report/my-reports", {
          // page: "1",
          sort: "desc",
          limit: "100",
        });

        const response = await fetchWithAuth(url);

        devLogger.log("🚀 ~ fetchReports ~ response:", response);
        setData(response);
      } catch (err: any) {
        setFetchReportsError(err.message || "Something went wrong");
      } finally {
        setFetchingReports(false);
      }
    };

    fetchReports();

    // eslint-disable-next-line
  }, []);

  return {
    reports: data?.reports,
    metaData: data?.metaData,
    fetchingReports,
    fetchReportsError,
    setFetchingReports,
    setFetchReportsError,
  };
};

export default useFetchUserReports;

type MetaDataType = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalPages: number;
  totalReports: number;
};

type DataType = {
  reports: FetchedReportData[];
  metaData: MetaDataType;
};
